<template>
  <div>
    <nav class="navbar navbar-light bg-white fixed-top">
      <div class="container-fluid px-0">
        <router-link to="/" class="navbar-brand text-primary">
          <!-- <a class="navbar-brand text-primary" href="#"> -->
          <img
            src="@/assets/image/icon/icons-01.svg"
            width="150px"
            class=""
            alt="..."
          />
          <!-- </a> -->
        </router-link>
        <a class="ml-md-2" href="#"
          ><img
            src="@/assets/image/icon/icons-03.svg"
            width="110px"
            class=""
            alt="..."
        /></a>
      </div>
    </nav>
    <!-- <a class="content-page-back-btn mt-2 ml-2" href="index.html"
      ><img
        src="@/assets/image/icon/手機-返回箭頭.svg"
        width="40px"
        class=""
        alt="..."
    /></a> -->
    <div class="container-fluid pb-3 main-box">
      <div class="row">
        <img
          id="pop-picture"
          :src="getPhoto(article.contentImage)"
          width="100%"
          height="100%"
        />
      </div>
      <div class="content-page-content-box my-3 px-1">
        <h3 class="content-page-title" id="pop-title">
          {{ article.articleTitle }}
        </h3>
        <p class="content-page-name text-dark">
          <span id="pop-name" class="mr-3">{{ article.name }}</span>
          <small id="pop-data" v-if="article.data !== '-'">
            {{ articleData[0] }}/{{ articleData[1] }}/{{ articleData[2] }}
          </small>
        </p>
        <hr />
        <p class="text-dark" id="pop-content" v-html="article.content"></p>
      </div>
      <div class="row">
        <div class="px-0 ml-auto mr-3 drop-box">
          <img
            class="toggle-share"
            src="@/assets/image/icon/icons-04.svg"
            width="100px"
            v-on:click="showDropItem = !showDropItem"
          />
          <div class="drop-share" v-show="showDropItem">
            <div
              class="drop-item"
              id="drop-copy"
              v-clipboard:copy="link"
              v-clipboard:success="onCopy"
            >
              <img
                src="@/assets/image/icon/單篇-連結.svg"
                height="20px"
                class="ml-auto mr-1"
              /><span class="small align-middle">複製連結</span>
            </div>
            <a
              id="share-line"
              href="javascript: void(window.open('https://social-plugins.line.me/lineit/share?url='.concat(encodeURIComponent(location.href))));"
            >
              <div class="drop-item">
                <img
                  src="@/assets/image/icon/單篇-LINE.svg"
                  height="20px"
                  class="ml-auto mr-1"
                /><span class="small align-middle">LINE</span>
              </div>
            </a>
            <a
              id="share-fb"
              href="javascript: void(window.open('http://www.facebook.com/share.php?u='.concat(encodeURIComponent(location.href))));"
            >
              <div class="drop-item">
                <img
                  src="@/assets/image/icon/單篇-FB.svg"
                  height="20px"
                  class="ml-auto mr-1"
                /><span class="small align-middle">Facebook</span>
              </div>
            </a>
            <div
              class="drop-item drop-close"
              v-on:click="showDropItem = !showDropItem"
            >
              <img
                src="@/assets/image/icon/單篇-XX.svg"
                height="20px"
                class="ml-auto mr-1"
              />
              <span class="small align-middle">關閉列表</span>
            </div>
          </div>
        </div>
        <div class="px-0 mr-auto">
          <a
            href="https://www.evergreen-hotels.com/chain2/offer/index.jsp?lang=zh-TW"
          >
            <img src="@/assets/image/icon/icons-07.svg" width="100px" />
          </a>
        </div>
      </div>
    </div>
    <div class="container-fluid" id="page-box">
      <div class="row">
        <div class="col-4 text-left " id="page-prev" @click="prevArticle()">
          <a href="#" class="text-primary"> &lt; 上一則</a>
        </div>
        <div class="col-4 text-center">
          <router-link to="/" class="text-primary">看更多故事</router-link>
        </div>
        <div
          class="col-4 text-right text-primary"
          id="page-next"
          @click="nextArticle()"
        >
          <a href="#" class="text-primary">下一則 &gt;</a>
        </div>
      </div>
    </div>
    <div class="footer-mobile container-fluid d-sm-none">
      <div class="row text-white h-100 footer-box">
        <div class="ml-auto col-12 col-sm-2 my-3">
          <a
            class="text-white"
            target="_blank"
            href="https://www.evergreen-hotels.com/"
            >長榮酒店</a
          >
        </div>
        <div class="col-12 my-3">
          <div class="row">
            <div class="mr-auto my-auto col-6 col-xl-4 ">
              <a
                class="text-white"
                target="_blank"
                href="https://www.evergreen-hotels.com/branch2/index.jsp?d1b_Sn=4&lang=zh-TW"
                >長榮桂冠酒店 (基隆)</a
              >
            </div>
            <div class="mr-auto my-auto col-6 col-xl-4 ">
              <a
                class="text-white"
                target="_blank"
                href="https://www.evergreen-hotels.com/branch2/index.jsp?d1b_Sn=7&lang=zh-TW"
                >長榮桂冠酒店 (台北)</a
              >
            </div>
            <div class="mr-auto my-auto col-6 col-xl-4 ">
              <a
                class="text-white"
                target="_blank"
                href="https://www.evergreen-hotels.com/branch2/index.jsp?d1b_Sn=5&lang=zh-TW"
                >長榮桂冠酒店 (台中)</a
              >
            </div>
            <div class="mr-auto my-auto col-6 col-xl-4 ">
              <a
                class="text-white"
                target="_blank"
                href="https://www.evergreen-hotels.com/branch2/index.jsp?d1b_Sn=6&lang=zh-TW"
                >台糖長榮酒店 (台南)</a
              >
            </div>
            <div class="mr-auto my-auto col-6 col-xl-4 ">
              <a
                class="text-white"
                target="_blank"
                href="https://jiaosi.evergreen-hotels.com/"
                >長榮鳳凰酒店 (礁溪)</a
              >
            </div>
            <div class="mr-auto my-auto col-6 col-xl-4 ">
              <a
                class="text-white"
                target="_blank"
                href="https://www.evergreen-hotels.com/branch2/index.jsp?d1b_Sn=65&lang=zh-TW"
                >長榮文苑酒店 (嘉義)</a
              >
            </div>
          </div>
        </div>
        <div
          class="col-12 col-sm ml-auto text-center small my-auto mobile-copyright"
        >
          Copyright © 2019 Evergreen International Corporation. All rights
          reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MobileDetect from 'mobile-detect'

import { ARTICLE } from '@/constant/article'

export default {
  data() {
    return { showDropItem: false }
  },
  beforeRouteEnter(to, from, next) {
    var md = new MobileDetect(window.navigator.userAgent)
    if (!md.phone()) {
      next({
        name: 'Home',
        params: { channel: 'article', id: to.params.articleId }
      })
    } else if (
      to.params.articleId > ARTICLE.length ||
      to.params.articleId < 1
    ) {
      next({ name: 'Home' })
    } else {
      next()
    }
  },
  computed: {
    article: function() {
      return ARTICLE[this.$route.params.articleId - 1]
    },
    articleData: function() {
      return this.article.data.split('<br>')
    },
    link: function() {
      return (
        location.protocol +
        '//' +
        location.host +
        location.pathname +
        '#/content/' +
        this.article.id
      )
    }
  },
  methods: {
    getPhoto: function(file) {
      return require('../assets/image/content/' + file + '.jpg')
    },
    nextArticle: function() {
      this.resetPage()
      if (this.article.id + 1 > ARTICLE.length) {
        this.$router.push({ name: 'MobileArticle', params: { articleId: 1 } })
      } else {
        this.$router.push({
          name: 'MobileArticle',
          params: { articleId: this.article.id + 1 }
        })
      }
    },
    prevArticle: function() {
      this.resetPage()
      if (this.article.id - 1 < 1) {
        this.$router.push({
          name: 'MobileArticle',
          params: { articleId: ARTICLE.length }
        })
      } else {
        this.$router.push({
          name: 'MobileArticle',
          params: { articleId: this.article.id - 1 }
        })
      }
    },
    resetPage: function() {
      this.showDropItem = false
    },
    onCopy: function() {
      alert('複製成功！')
    }
  }
}
</script>

<style scoped>
nav {
  padding-top: 22px;
  padding-bottom: 22px;
  padding-left: 22px;
  padding-right: 22px;
}
.content-page-back-btn {
  color: #fff;
  opacity: 0.6;
  position: absolute;
}

.content-page-back-btn:hover {
  opacity: 0.9;
  color: #fff;
}

.content-page-title {
  font-family: 'Noto Serif TC', serif;
  font-weight: 600;
}

.content-page-name {
  font-family: 'Noto Serif TC', serif;
  font-weight: 600;
}
.footer-mobile {
  min-height: 80px;
  background-color: #1a1a1a;
  font-size: 16px;
}

.footer-box {
  min-height: 80px;
  font-size: 16px;
}

.mobile-copyright {
  font-size: 12px;
}
#page-box {
  height: 60px;
  line-height: 60px;
  background-color: #dddddd;
  font-size: 16px;
}
.main-box {
  background-color: #fff;
  padding-top: 88px;
}
hr {
  border: 1px solid #669070;
}
.drop-share {
  position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  float: left;
  margin: 0.125rem 0px 0px;
  font-size: 1rem;
  color: rgb(102, 144, 112);
  text-align: left;
  list-style: none;
  background-color: rgb(255, 255, 255);
  background-clip: padding-box;
  border-radius: 0.25rem;
  width: 100px;
  box-shadow: rgba(0, 0, 0, 0.176) 0px 0.5rem 1rem;
}
.drop-box {
  position: relative;
}
</style>
